import React, { useEffect, useState } from "react";

import {
  assignSeatmapToEvent,
  applyTemplateToEvent,
} from "../../../../utilities/api";

import Card from "react-bootstrap/Card";

import { ChooseMap } from "./ChooseMap";
import { SelectMapModal } from "../SelectMapModal";

export default function SelectMap({
  venueSlug,
  eventId,
  setStep,
  setIsTemplate,
  templates,
  seatmaps,
  isLoading,
  reloadData,
}) {
  const [show, setShow] = useState(false);

  const [choice, setChoice] = useState(null);

  // local state of selectedMapId in case of reverting back to original value
  const [selectedId, setSelectedId] = useState(null);

  const [isSaving, setIsSaving] = useState(false);

  const handleClick = (_, choice) => {
    setChoice(choice);
    setIsTemplate(choice === 2);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setChoice(null);
    setSelectedId(null);
  };

  const handleCancel = () => handleClose();

  // select new map or template
  const handleSubmit = () => {
    if (!selectedId) return;
    setIsSaving(true);
    const isTemplate = choice === 2;
    const numericId = Number(selectedId);
    if (isTemplate && (Number.isNaN(numericId) || numericId <= 0)) {
      console.error("Invalid template selection");
      setIsSaving(false);
      return;
    }

    if (isTemplate) {
      // Apply template (seatmap + pricing + ticket groups)
      applyTemplateToEvent({
        eventUUID: eventId,
        templateId: numericId,
      })
        .then(() => reloadData())
        .then(() => {
          handleClose();
          setIsSaving(false);
          setStep(2);
        })
        .catch((err) => {
          console.error(err);
          setIsSaving(false);
        });
    } else {
      // Add selected seatmap configuration to event
      assignSeatmapToEvent({
        eventUUID: eventId,
        seatMapID: numericId,
      })
        .then(() => reloadData())
        .then(() => {
          handleClose();
          setIsSaving(false);
          setStep(2);
        })
        .catch((err) => {
          console.error(err);
          setIsSaving(false);
        });
    }
  };

  return (
    <div className="position-relative">
      <div data-testid="select-map-section">
        <section>
          <header className="section-header section-heading section-heading--secondary">
            <h1>Seat map</h1>
          </header>
          <Card body className="card--light">
            <ChooseMap handleClick={handleClick} />
          </Card>
        </section>
      </div>

      <SelectMapModal
        show={show}
        venueSlug={venueSlug}
        choice={choice}
        isLoading={isLoading}
        maps={seatmaps}
        templates={templates}
        selected={selectedId}
        setSelected={setSelectedId}
        initialSelected={null}
        isSaving={isSaving}
        handleClose={handleClose}
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
      />
    </div>
  );
}
